var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMakeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1599_27798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1599_27798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 16H16V13H19V11H16V8H14V11H11V13H14V16ZM6 20.5C4.18333 19.8667 2.72917 18.7708 1.6375 17.2125C0.545833 15.6542 0 13.9167 0 12C0 10.0833 0.545833 8.34583 1.6375 6.7875C2.72917 5.22917 4.18333 4.13333 6 3.5V5.7C4.76667 6.28333 3.79167 7.14167 3.075 8.275C2.35833 9.40833 2 10.65 2 12C2 13.35 2.35833 14.5917 3.075 15.725C3.79167 16.8583 4.76667 17.7167 6 18.3V20.5ZM11.4875 20.2875C10.3958 19.8125 9.44583 19.1708 8.6375 18.3625C7.82917 17.5542 7.1875 16.6042 6.7125 15.5125C6.2375 14.4208 6 13.25 6 12C6 10.75 6.2375 9.57917 6.7125 8.4875C7.1875 7.39583 7.82917 6.44583 8.6375 5.6375C9.44583 4.82917 10.3958 4.1875 11.4875 3.7125C12.5792 3.2375 13.75 3 15 3C16.25 3 17.4208 3.2375 18.5125 3.7125C19.6042 4.1875 20.5542 4.82917 21.3625 5.6375C22.1708 6.44583 22.8125 7.39583 23.2875 8.4875C23.7625 9.57917 24 10.75 24 12C24 13.25 23.7625 14.4208 23.2875 15.5125C22.8125 16.6042 22.1708 17.5542 21.3625 18.3625C20.5542 19.1708 19.6042 19.8125 18.5125 20.2875C17.4208 20.7625 16.25 21 15 21C13.75 21 12.5792 20.7625 11.4875 20.2875Z",
    fill: "#71717A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeIcon);
export default __webpack_public_path__ + "static/media/make-icon.d722d69c4c68e9d6c20c68f2c92c9a5c.svg";
export { ForwardRef as ReactComponent };